import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type { LeaveEventLeaf } from 'modules/calendar/components/TeamView/components/Store'

import styles from './index.module.css'

const cx = classNames.bind(styles)

interface Props {
  leaveEventLeaf: LeaveEventLeaf
  dayClasses: Record<string, boolean>
  year: number | undefined
}

const Cell = ({ leaveEventLeaf, dayClasses, year }: Props) => {
  const [open, toggle] = useToggle()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const key = leaveEventLeaf.data.leaveId
  const contentAttr: { onClick?: () => void } = {}
  const className = cx('content', dayClasses, leaveEventLeaf.contentClasses)

  const onClickCell = (leaveId: string) => {
    navigate(navigation.calendar.teamView.leavesEditLeaveId.fullPath({ leave_id: leaveId }))
  }

  if (leaveEventLeaf.data.canManageLeave) {
    contentAttr.onClick = () => {
      if (year !== undefined) {
        onClickCell(leaveEventLeaf.data.leaveId)
      }
    }
  }

  const backgroundColor = leaveEventLeaf.data.color ?? ''

  const content = (
    <div
      className={styles.contentInner}
      style={{
        backgroundColor,
      }}
      {...contentAttr}
    />
  )

  const leaveName = leaveEventLeaf.data.leaveTypeName

  if (!leaveName) {
    return (
      <div key={key} className={className}>
        {content}
      </div>
    )
  }

  const leaveTooltip: string[] = !leaveEventLeaf.data.approved
    ? [
        i18n.t('team_view.tooltip_pending_leave', {
          leaveName,
        }),
      ]
    : [leaveName]

  if (leaveEventLeaf.data.leaveDescriptionTooltip) {
    leaveTooltip.push(leaveEventLeaf.data.leaveDescriptionTooltip)
  }

  return (
    <Tooltip.Alt
      attachment="bottom center"
      open={open}
      toggle={toggle}
      label={leaveTooltip.join(' - ')}
      className={className}
      textAlign="center"
    >
      {content}
    </Tooltip.Alt>
  )
}

export default Cell
